var generateComponentTheme = function generateComponentTheme(_ref) {
  var borders = _ref.borders,
    colors = _ref.colors,
    typography = _ref.typography,
    spacing = _ref.spacing;
  return {
    bankRowBorderWidth: borders.widthSmall,
    bankRowBorderColor: colors.contrasts.grey1214,
    bankInfoMargin: spacing.small,
    bankTitleFontSize: typography.fontSizeSmall,
    bankTitlePadding: spacing.xSmall,
    bankTitleLinkColor: colors.contrasts.grey125125,
    bankTitleLinkHoverColor: colors.contrasts.grey125125,
    bankDetailsColor: colors.contrasts.grey4570,
    bankDetailsFontSize: typography.fontSizeXSmall,
    bankOptionsMargin: spacing.small,
    BankOptionIconMargin: spacing.xSmall,
    BankOptionIconFontSize: typography.fontSizeMedium,
    deletePrefaceMargin: spacing.xxSmall
  };
};
export default generateComponentTheme;